var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.77148,
    y: 1.771,
    width: 5.66667,
    height: 5.66667,
    rx: 1.41667,
    stroke: "#81BC45",
    strokeWidth: 1.275
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5625,
    y: 1.771,
    width: 5.66667,
    height: 5.66667,
    rx: 1.41667,
    stroke: "#81BC45",
    strokeWidth: 1.275
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.77148,
    y: 9.5625,
    width: 5.66667,
    height: 5.66667,
    rx: 1.41667,
    stroke: "#81BC45",
    strokeWidth: 1.275
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5625,
    y: 9.5625,
    width: 5.66667,
    height: 5.66667,
    rx: 1.41667,
    stroke: "#81BC45",
    strokeWidth: 1.275
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllIcon);
export default __webpack_public_path__ + "static/media/all_icon.24aac701f9abe745df5706fce23d91e9.svg";
export { ForwardRef as ReactComponent };